import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {ButtonConfig, ModalService} from '@collab/comp-library';
import { ModalConfig } from '@collab/comp-library/ui/modal/modal.config';
import { LandingPageService } from 'src/app/pages/landing-page/service/landing-page.service';
import { PNG } from '../../constants/constants';
import { ROUTE_ASSET_LIB_COMPS, ROUTE_ASSETS_IMAGES} from '../../constants/route-paths';
import { ContactUsService } from '../contact-us/service/contact-us.service';
import { VideoService } from '../video/service/video.service';
import { StartTrialContent } from './start-trial-content';


@Component({
    selector: 'app-all-products-card',
    templateUrl: './all-products-card.component.html',
    styleUrls: ['./all-products-card.component.scss']
})
export class AllProductsCardComponent implements OnInit {
    @Input() public productDetails: any;

    @Output() public startTrailProductId: EventEmitter<any> = new EventEmitter();

    public videoUrl = '';
    public posterUrl = '';
    public startTrailDetails: any;
    public currentProductId!: string;
    public modalConfig: ModalConfig = {
        id: 'modal',
		type: 'alert',
		title: "",
		closeButton: true,
		primaryButtonConfig: {
			text: "Start Free Trial",
			buttonType: "primary",
			buttonSize: "medium",
			imageUrl: "",
			linkURL: "",
		  },
    };
    public trialModalConfig: ModalConfig = {
        id: 'trail-success',
		type: 'alert',
		title: "Trial Successfully Started",
		closeButton: true,
		primaryButtonConfig: {
			text: "Ok",
			buttonType: "primary",
			buttonSize: "medium",
			imageUrl: "",
			linkURL: "",
		  },
    };
    public trialExpiryDate = null;
    public isLaunchEnable!: boolean;
    public showTrail!: boolean;
    public isWatchDemo!: boolean;
    public showContactUs!: boolean;
    public showLaunchTrailBtn!: boolean;
    public showStartTrail!: boolean;
    public isLaunchTrail!: boolean;
    public isTrialExpiredAndBuyNow!: boolean;
    public startTrialContent = StartTrialContent;
    public modalData: any = null;
    public mlopsUrl = '/mlops/';
    public page = 'Landing Page';
    public isNew:boolean=true;

    public buyNowBtnConfig: ButtonConfig = {
        text: 'Buy Now',
        buttonType: 'primary',
        iconURL: '',
        imageUrl: '',
        linkURL: ''
    };
    public startTrailBtnConfig: ButtonConfig = {
        text: 'Start Trial',
        buttonType: 'primary',
        iconURL: '',
        imageUrl: '',
        linkURL: ''
    };
    public launchTrailBtnConfig: ButtonConfig = {
        text: 'Launch Trial',
        buttonType: 'primary',
        iconURL: '',
        imageUrl: '',
        linkURL: ''
    };
    public watchButtonBtnConfig: ButtonConfig = {
        text: 'Watch Demo',
        buttonSize:'small',
        buttonType: 'secondary',
        iconURL: '',
        imageUrl: '',
        linkURL: ''
    };
    public LaunchApplicationBtnConfig: ButtonConfig = {
        text: 'Launch Application',
        buttonType: 'primary',
        iconURL: '',
        imageUrl: '',
        linkURL: ''
    };
    public contactUsBtnConfig: ButtonConfig = {
        text: 'Contact Us',
        buttonSize:'small',
        buttonType: 'secondary',
        iconURL: '',
        imageUrl: '',
        linkURL: ''
    };
    public startFreeTrailBtnConfig: ButtonConfig = {
        text: 'Start Free Trial',
        buttonType: 'primary',
        iconURL: '',
        imageUrl: '',
        linkURL: '',
    };
    public okBtnConfig: ButtonConfig = {
        text: 'ok',
        buttonType: 'primary',
        iconURL: '',
        imageUrl: '',
        linkURL: ''
    };






    constructor(private contactUsService: ContactUsService, private modalService: ModalService, private videoService: VideoService, public landingPageService: LandingPageService,private cdr: ChangeDetectorRef) {
    }

    public ngOnInit(): void {
        this.addPermissions();
        this.showLaunchTrailBtn = new Date(this.productDetails?.productDetails?.trialPeriod?.startDate) < new Date() &&
        new Date(this.productDetails?.productDetails?.trialPeriod?.endDate) > new Date();
        if (this.productDetails.launchEligible) {
            if (this.productDetails.subscription) {
                this.isLaunchEnable = true;
                return;
            }

            if (!this.productDetails.subscription && !this.productDetails.trialPeriod) {
                this.showStartTrail = true;
            }

            if (this.productDetails.trialPeriod && !this.productDetails.trialPeriod.expired) {
                this.isLaunchTrail = true;
            }

            if (this.productDetails?.trialPeriod && this.productDetails.trialPeriod.expired && !this.productDetails.subscription) {
                // this.isTrialExpiredAndBuyNow = true;
                this.showContactUs= true;
            }
        } else {
            this.showContactUs = true;
        }
        this.trialExpiryDate = this.landingPageService.trialExpiryDate;
    }

    /**
     *
     * this methos will return the url for icons
     * @param {string} icon
     * @return {*}  {string}
     * @memberof NavbarComponent
     */
     public getUrl(icon: string): string {
        return ROUTE_ASSET_LIB_COMPS + ROUTE_ASSETS_IMAGES + icon + PNG || '';
    }

    public openVideoPlayer(product: any) {
        this.videoUrl = product.videoDemoUrl;
        this.posterUrl = 'assets/posterImage.png';
        this.videoService.openVideoPalyer(this.videoUrl);
        this.modalService.open(product.productCode);
    }

    public getStartTrailDetails(productId: any, key: string) {
        this.currentProductId = productId;
        this.modalData = !!this.startTrialContent[key] ? this.startTrialContent[key] : null;
        this.modalConfig.id = 'modal_' + productId;
        this.modalConfig.title = this.modalData.title;
        this.cdr.detectChanges();
        this.modalService.open('modal_' + productId);
    }
    
   public closeModal(id:string){
        this.modalService.close('trail-sucess')
   }

    public getId(productId: any) {
        return 'product' +  productId;
    }

    public getExpiryDate(date: any) {
        return new Date(date).getUTCDate() + ' ' + new Date(date).toLocaleString('default', { month: 'short' }) + ' ' + new Date(date).getUTCFullYear();
    }

    public done(id: string) {
        if(id === 'trial-success') {
            this.cdr.detectChanges();
            this.landingPageService.trialExpiryDate = null;
            this.landingPageService.emitMarketplaceAPI();
        }
        this.modalService.close(id);
    }

    public startFreeTrail(productId: any) {
        this.cdr.detectChanges();
        this.modalService.close('modal_' + this.currentProductId);
        this.landingPageService.getStartTrailDetails(productId).subscribe((res: any) => {
            this.startTrailDetails = res;
            this.landingPageService.trialExpiryDate = this.getExpiryDate(res.endDate);
            this.cdr.detectChanges();
            this.modalService.open('trail-success');
            this.showStartTrail = false;
            this.isLaunchTrail = true;
        });
    }

    public goTo(url: string, _target?: string) {
        window.open(url, '_blank');
    }

    public gotoContactUs() {
        this.contactUsService.isContactUsShow = true;
    }

    public gotoMLops() {
        window.open(this.mlopsUrl, '_blank');
    }

    public addPermissions() {
        switch (this.productDetails.productCode) {
            case 'ITA':
                this.productDetails['demoPermission'] = 'ITA Watch Demo';
                this.productDetails['launchTrialPermission'] = 'ITA Launch Trial';
                this.productDetails['startTrialPermission'] = 'ITA Start Trial';
                this.productDetails['launchPermission'] = 'ITA Launch Application (if subscribed)';
                break;
            case 'IAF':
                this.productDetails['demoPermission'] = 'IAF Watch Demo';
                this.productDetails['launchTrialPermission'] = 'IAF Launch Trial';
                this.productDetails['startTrialPermission'] = 'IAF Start Trial';
                this.productDetails['launchPermission'] = 'IAF Launch Application (if subscribed)';
                break;
        
            default:
                break;
        }
    }
}
